
  $(function() {
    function applyIfExists() {
      if ($('.swatch-tabs').length && $('.size-chart-flex').length) { // guard [web:82]
        var h = Math.round($('.swatch-tabs').outerHeight() || 0) + 10; // compute [web:69]
        $('.size-chart-flex').css('top', h + 'px'); // apply [web:55]
        return true;
      }
      return false;
    }

    if (!applyIfExists()) {
      var observer = new MutationObserver(function() {
        if (applyIfExists()) observer.disconnect(); // stop once applied [web:94][web:16]
      });
      observer.observe(document.body, { childList: true, subtree: true }); // watch additions [web:16]
    }

    $(window).on('resize', applyIfExists); // keep in sync on resize [web:76]
  });




document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".swatch-tabs button");
  const items = document.querySelectorAll(".swatch-container .color-list-in");

  function normalizeFilter(filter) {
    return (filter || "all").toLowerCase().trim();
  }

  function setActiveTab(filter) {
    const f = normalizeFilter(filter);

    // Update active tab class
    buttons.forEach(btn => btn.classList.toggle("active", btn.dataset.filter === f));

    // Show/hide items
    items.forEach(item => {
      const match = (f === "all" || item.classList.contains(f));
      item.style.display = match ? "block" : "none";
    });

    // Update URL ?filter param without reload
    const url = new URL(window.location.href);
    url.searchParams.set("filter", f);
    history.replaceState(null, "", url);

    // Update href on only visible items so they preserve filter on click

    items.forEach(item => {
      const isVisible = item.style.display === "block";
      if (!isVisible) return;

      const anchor = item.matches("a.color-list-in") ? item : item.querySelector("a");
      if (!anchor || !anchor.href) return;

      const target = new URL(anchor.href, window.location.origin);
      target.searchParams.set("filter", f);
      anchor.href = target.toString();
    });
  }

  // Initialize from URL
  const params = new URLSearchParams(window.location.search);
  const initial = normalizeFilter(params.get("filter") || "all");
  setActiveTab(initial);

  // Handle tab clicks
  buttons.forEach(button => {
    button.addEventListener("click", () => {
      setActiveTab(button.dataset.filter);
    });
  });

  // Optional safety: if another script changes visibility later,
  document.addEventListener("click", function (e) {
    const activeBtn = document.querySelector(".swatch-tabs button.active");
    const f = activeBtn ? normalizeFilter(activeBtn.dataset.filter) : "all";
    const link = e.target.closest(".color-list-in a, a.color-list-in");
    if (!link) return;

    const item = link.closest(".color-list-in") || link;
    if (!item) return;

    const isVisible = item.style.display === "block" || (f === "all" || item.classList.contains(f));
    if (!isVisible) return;

    const target = new URL(link.href, window.location.origin);
    target.searchParams.set("filter", f);
    link.href = target.toString();
  });
});


function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  let user = getCookie("username");
  if (user != "") {
    alert("Welcome again " + user);
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}
$(document).ready(function(){
  
  // $(".main-product-block-col").each(function(){
  //   var thiss = $(this);
  //   var getTemplate = $(this).attr("template");
  //   var getProductlink = $(this).find(".product-link").attr("href");
  //   $.ajax({
  //     type:"GET",
  //     url:getProductlink+"?view="+getTemplate,
  //     async:false,
  //     dataType:"html",
  //     success: function(data){
  //       //console.log(data)
  //       var everyday = $(data).find("fieldset.js.product-form__input.color_option.everyday-colors .color-lists").html();
  //       var seasonal = $(data).find("fieldset.js.product-form__input.color_option.seasonal-color .color-lists").html();
  //       console.log(everyday)
  //       console.log(seasonal)
  //       thiss.find(".collection-pr-color-swatches").append(everyday);
  //       thiss.find(".collection-pr-color-swatches").append(seasonal)
  //       thiss.find(".collection-pr-color-swatches .color-list-in").slice(0, 6).wrapAll('<div class="parent1"></div>');
    
  //       // Wrap the rest of the divs in another parent div
  //       thiss.find(".collection-pr-color-swatches .color-list-in").slice(6).wrapAll('<div class="parent2"></div>');
  //       var listItems = thiss.find(".collection-pr-color-swatches .parent2 .color-list-in").length;
  //       if ( listItems > 0 )
  //       {
  //         $('<a href="'+getProductlink+'" >'+'+ '+listItems+' more'+'</a>').insertAfter(thiss.find(".collection-pr-color-swatches .parent1"));
  //       }
  //     }
  //   })
  // })

  
  $(".custom-differentiate").find("input").on("change", function(){
    var get = $(this).val();
    $(this).parents(".custom-differentiate").find("p.everyday_colors.colors_class span").text(get)
  })
  var checked = $(".custom-differentiate").find("input:checked").val();
  $(".custom-differentiate").find("input:checked").parents(".custom-differentiate").find("p.everyday_colors.colors_class span").text(checked)

  $("a.color-list-in").on("click", function(){
    var text = $(this).find("label").attr("data-val-app");
    $(this).parents("fieldset.js.product-form__input").find("span").text(text);
    $(this).addClass("active-color")
    $(this).prevAll("a.color-list-in").removeClass("active-color");
    $(this).nextAll("a.color-list-in").removeClass("active-color");
  })
var selected_color = $("a.color-list-in.active-color").find("label").attr("active-color");
  console.log(selected_color)
  $("a.color-list-in.active-color").parents("fieldset.js.product-form__input").find("span").text(selected_color);
  if ( $("fieldset.option-selector[data-option='Size']").length > 0 )
  {
    $(".disabled-button").text("Select Size");
  }
  else
  {
    $(".disabled-button").removeClass("disabled-button")
  }
  $("fieldset.option-selector[data-option='Size']").find(".option-selector__btns input").prop('checked', false);
  $("fieldset.option-selector[data-option='Size']").find(".option-selector__btns input").on("change", function(){
    var selectedopt = $(this).val();
    setCookie("selected_size", $(this).val(), 1);
    $("a.color-list-in").removeClass("disable-it");
    $(".disabled-button").text("Add To Cart");
    $(".disabled-button").removeClass("disabled-button")
    // var getVal = $(".size-value[size-label='"+$(this).val()+"']").attr("data-title-grey");
    // console.log(getVal)
    // var myArray = getVal.split(",");
    // setTimeout(function(){
    // for ( var i=0; i < myArray.length; i++ )
    //   {
    //     $("[data-val-app='"+myArray[i]+"']").parents("a").addClass("disable-it")
    //   }
    //   }, 100);
    $("a.color-list-in").each(function(){
      var getInventory = $(this).find(".variant-picker-options span.variant-info[v-name='"+selectedopt+"']").attr("v-inventory");
      getInventory = parseInt(getInventory);
      console.log(getInventory);
      if ( getInventory <= 0 )
      {
        $(this).addClass("disable-it");
      }
    })




    
  })

  var selectedColor = $("a.color-list-in.active-color label").attr("at-color");
  console.log(selectedColor)
  var getLink1 = $(".pp-bt-product-shortsleevevneck-product a.button_1.button").attr("href");
  var getLink2 = $(".pp-bt-product-shortsleevevneck-product a.button_2.button").attr("href");
  $(".pp-bt-product-shortsleevevneck-product a.button_1.button").attr("href", getLink1+"-"+selectedColor)
  $(".pp-bt-product-shortsleevevneck-product a.button_2.button").attr("href", getLink2+"-"+selectedColor)

  console.log(selectedColor)
  var getLink1 = $(".pp-bt-product-shortsleevecrewneck-product a.button_1.button").attr("href");
  var getLink2 = $(".pp-bt-product-shortsleevecrewneck-product a.button_2.button").attr("href");
  $(".pp-bt-product-shortsleevecrewneck-product a.button_1.button").attr("href", getLink1+"-"+selectedColor);
  $(".pp-bt-product-shortsleevecrewneck-product a.button_2.button").attr("href", getLink2+"-"+selectedColor);


  var getSelectedSize = getCookie("selected_size");
  if (getSelectedSize != "") {
    console.log(getSelectedSize)
    $("fieldset.option-selector[data-option='Size']").find(".option-selector__btns input[value="+getSelectedSize+"]").trigger("click");
    $(".disabled-button").text("Add To Cart");
    $(".disabled-button").removeClass("disabled-button")
  }

  
                  $(".lightly-spaced-row.lightish-spaced-row-above.not-in-quickbuy .fixed-layout").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
  nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  setTimeout(function(){
  //document.querySelector("square-placement").shadowRoot.querySelector(".afterpay-main-text").style.display = "none";
    }, 10000);
 
})


// function myFunction() {
//   const element = document.getElementById("pricing-table");
//   element.scrollIntoView({
//   behavior: 'smooth'
//   });
// }
$(document).ready(checkContainerr);
$(document).ready(checkContainerrr);
function checkContainerr() {
  if($('.related-productss').is(':visible')){ //if the container is visible on the page
    console.log("pr-visible")
    setTimeout(function(){
   $('.related-productss ').find(".product-grid").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
  nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
     }, 2000);
  } else {
    //console.log("not found");
    setTimeout(checkContainerr, 50); //wait 50 ms, then try again
    
  }
}
function checkContainerrr() {
  if($('square-placement').is(':visible')){
   // console.log("element found");
    
  }
  else
  {
    //console.log("not found");
    setTimeout(checkContainerrr, 50);
  }
}
$(document).ready(function() {
   $('.filter-group').each(function() {
        const filterGroup = $(this);
        const filterItems = filterGroup.find('.filter-group__item');
        const notIncludeItems = filterGroup.find('.filter-group__item[data-tag="not-include"]');
        // Check if the length of all filter items is 1 and the length of not include items is also 1
        if (filterItems.length == 1 && notIncludeItems.length == 1) {
            filterGroup.hide();
        }else{
          filterGroup.find('toggle-target.filter-group__heading').removeClass('toggle-target-toggler--is-hidden');
          filterGroup.find('.filter-group__items').removeClass('toggle-target--hidden');
        }
});
});

$(document).ready(function () {
    function filterProducts() {
      
        let activeFilters = [];
        $(".filter-group__applied-item").each(function () {
            activeFilters.push($(this).attr("data-active-filter"));
        });

        // Loop through each product block
        $(".product-block").each(function () {
            let soldoutAttr = $(this).attr("data-soldout-variants") || "";
            let availableAttr = $(this).attr("data-available-variants") || "";

            let soldoutVariants = soldoutAttr.split(",").map(v => v.trim()).filter(v => v !== "");
            let availableVariants = availableAttr.split(",").map(v => v.trim()).filter(v => v !== "");

            let isSoldOut = activeFilters.some(filter => soldoutVariants.includes(filter));
            let isAvailable = activeFilters.some(filter => availableVariants.includes(filter));

            // If available, always show (takes priority)
            if (isAvailable) {
                $(this).show();
            } 
            // If sold out and NOT available, hide
            else if (isSoldOut) {
                $(this).hide();
            } 

        });
    }

    // Run filtering on page load
    filterProducts();

    // Observe changes in .template-collection
    const observer = new MutationObserver(function () {
        filterProducts();
    });

    let templateCollection = document.querySelector(".template-collection");
    if (templateCollection) {
        observer.observe(templateCollection, {
            childList: true,
            subtree: true,
            attributes: true
        });
    }

    // Re-run when a filter is clicked
    $(document).on("click", ".filter-group__item", function () {
        setTimeout(filterProducts, 100);
    });
});



  function moveSquarePlacement() {
    const squarePlacement = document.querySelector('square-placement');

    if (!squarePlacement) return;

    // Remove existing placement to avoid duplicates
    squarePlacement.remove();

    const desktopContainer = document.querySelector('.product-form .product-p-r-c');
    const mobileContainer = document.querySelector('.mobile-view-title-and-info .product-p-r-c');

    if (window.innerWidth <= 767) {
      // Mobile: Insert after mobile .product-p-r-c
      if (mobileContainer) {
        mobileContainer.insertAdjacentElement('afterend', squarePlacement);
      }
    } else {
      // Desktop: Insert after desktop .product-p-r-c
      if (desktopContainer) {
        desktopContainer.insertAdjacentElement('afterend', squarePlacement);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', moveSquarePlacement);
  window.addEventListener('resize', moveSquarePlacement);


